import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FileSelectorModel} from '@features/file-manager/models/file-selector.model';
import {DataMappingItem, DataMappingSourceOption} from '@features/data-mapping/models/data-mapping.model';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Api} from '@shared/constants/common-field.constants';
import {QuestionnaireFieldConfig} from '@shared/models/common.models';
import {CommandService} from '@core/services/command.service';
import {DialogService} from '@shared/services/dialog-service';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {MatSelectChange} from '@angular/material/select';
import {DialogModel} from '@shared/models/dialog.model';
import {AbstractControl, FormControl} from '@angular/forms';

@Component({
    standalone: false,
    selector: 'app-data-mapping-source-or-destination-selector',
  templateUrl: './data-mapping-source-or-destination-selector.component.html',
  styleUrls: ['./data-mapping-source-or-destination-selector.component.scss']
})
export class DataMappingSourceOrDestinationSelectorComponent implements OnInit {
  @Input() formControl: FormControl;
  @Input() data: DialogModel;
  @Input() label: string;
  @Input() hasSelectedValue = true;
  @Output() handleSelectionChange = new EventEmitter<any>();
  sourceOptions = [
    {id: 'itp-fields', value: 'ITP Fields', isChecked: false},
    {id: 'questionnaire', value: 'Questionnaire', isChecked: false},
    // {id: 'data-mapping', value: 'Data Mapping', isChecked: false},
    // {id: 'notebook', value: 'Notebook', isChecked: false},
    // {id: 'form', value: 'Form', isChecked: false}
  ];
  sourceOption: DataMappingSourceOption;
  sourceApiMappings: QuestionnaireFieldConfig[];
  selectedSource: QuestionnaireFieldConfig;
  relativePath: string;
  selectedItems: any;
  questionnaireNameDisplayText: string;
  returns: 'single' | 'list';
  selectedItem: any;


  constructor(private commandService: CommandService,
              private dialogService: DialogService,
              private platformQueryService: PlatformQueryService) {
  }

  ngOnInit(): void {
    if (this.hasSelectedValue) {
      this.sourceOption = this.sourceOptions[0];
      this.getSourceMappings();
      this.getSelectedDataMapping();
    }
    this.returns = this.data.input.returns ?? 'list';
  }

  sourceOptionChange($event: MatSelectChange) {
    console.log('[Change Event]', $event);
    this.sourceOption = $event.value;
    this.handleSourceOptionChange();
  }

  onSourceSelectionChange($event: MatSelectChange) {
    this.selectedSource = $event.value;
    this.emitValueOnChange();
  }

  sourceOptionClicked(option: DataMappingSourceOption) {
    console.log('[Click Event]', option);
    this.sourceOption = option;
    this.handleSourceOptionChange();
  }

  private handleSourceOptionChange() {
    switch (this.sourceOption.id) {
      case 'itp-fields':
        this.getSourceMappings();
        break;
      case 'questionnaire':
        const fileSelectorModel = new FileSelectorModel();
        fileSelectorModel.parentId = 'Team Drives';
        fileSelectorModel.skipBreadcrumbItem = false;
        fileSelectorModel.isClientDrive = true;
        fileSelectorModel.overrideParentId = true;
        fileSelectorModel.iconViewModels = [];
        fileSelectorModel.fileExtensionTypes = ['.qnr'];
        this.dialogService.showOrbitaxDriveFileSelector(fileSelectorModel).subscribe(res => {
          console.log('[Selected File]', res);
          if (res && res.action === 'OK') {
            this.selectedItems = res.data.input.selectedItems;
            if (this.returns === 'single') {
              this.selectedItem = res.data.input.selectedItems[0];
              this.questionnaireNameDisplayText = this.selectedItem.name;
            } else {
              const fileNames = this.getCommaSeparatedFileNames();
              this.questionnaireNameDisplayText = `${fileNames} file(s) selected`;
            }
            this.emitValueOnChange();
          }
        });
        break;
      default:
        break;
    }
  }

  private getCommaSeparatedFileNames() {
    let files = '';
    for (let idx = 0; idx < this.selectedItems.length; idx++) {
      files += this.selectedItems[idx].name;
      if (idx < this.selectedItems.length - 1) {
        files += ', ';
      }
    }
    return files;
  }

  private emitValueOnChange() {
    const payload = {
      sourceOption: this.sourceOption,
      selectedItems: this.selectedItems,
      selectedItem: this.selectedItem,
      selectedSource: this.selectedSource
    };
    if (this.formControl) {
      this.formControl.setValue(payload);
    }

    this.handleSelectionChange.emit(payload);
  }

  private getSourceMappings(dataMapping?: DataMappingItem, key?: string) {
    const queryCommand = new PlatformQuery();
    queryCommand.name = 'QuestionnaireFieldConfigQuery';
    queryCommand.api = Api.FileStoreApi;
    this.platformQueryService.executeQuery(queryCommand).subscribe(response => {
      this.sourceApiMappings = response.fieldValues['QuestionnaireFieldConfig'];
      console.log('[Source Mapping]', this.sourceApiMappings);
      if (dataMapping && key) {
        this.selectedSource = this.sourceApiMappings.filter(item => item.sourceType === dataMapping[key])[0];
      } else {
        this.selectedSource = this.sourceApiMappings[0];
      }
      this.emitValueOnChange();
    });
  }

  private getSelectedDataMapping() {
    const queryCommand = new PlatformQuery();
    queryCommand.name = 'GetDataMappingQuery';
    queryCommand.api = Api.FileStoreApi;
    queryCommand.fieldValues['DataMappingItemId'] = this.data.input['dataMappingItemId'];
    this.platformQueryService.executeQuery(queryCommand).subscribe(response => {
      if (response && response.fieldValues['DataMapping']) {
        const dataMapping = response.fieldValues['DataMapping'] as DataMappingItem;
        this.convertToSelectedSource(dataMapping);
      }
    });
  }

  private convertToSelectedSource(dataMapping: DataMappingItem) {
    const selectorType = this.data.input.type;
    switch (selectorType) {
      case 'SOURCE':
        if (dataMapping.sourceType) {
          this.sourceOption = DataMappingSourceOption.getItpFiledDataMappingSourceOption();
          this.getSourceMappings(dataMapping, 'sourceType');
        } else if (dataMapping.sourceFilePath) {
          this.sourceOption = DataMappingSourceOption.getQuestionnaireFieldDataMappingSourceOption();
          this.questionnaireNameDisplayText = dataMapping.sourceName;
        }
        break;
      case 'DESTINATION':
        if (dataMapping.targetType) {
          this.sourceOption = DataMappingSourceOption.getItpFiledDataMappingSourceOption();
          this.getSourceMappings(dataMapping, 'targetType');
        } else if (dataMapping.targetFilePath) {
          this.sourceOption = DataMappingSourceOption.getQuestionnaireFieldDataMappingSourceOption();
          this.questionnaireNameDisplayText = dataMapping.targetName;
        }
        break;
    }
  }
}
